var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex pa-2",attrs:{"outlined":"","tile":""}},[_c('div',[_vm._v("I'm a flexbox container!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }